module.exports = __webpack_public_path__ + "img/take-off-shoes.bd7a2861.svg";